// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import utils from './jslib/utils'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import  uihelper from './jslib/UIHelper'
import Vconsole from 'vconsole'
// import {getBucketDomain} from './api/api.js'
import common from './mixins/common'
import mVueTouch from "./jslib/tools/mTouch"
import vant from 'vant'
import 'vant/lib/index.css'
import BaiduMap from 'vue-baidu-map'
import store from "@/vuex/store";

import Vuex from "vuex"
Vue.config.productionTip = false

// if(!location.origin.includes('//localhost:') && !(/^http(s?):\/\/h5.mofanghouse.com/).test(location.origin)){
//   let vConsole = new Vconsole()
//   Vue.use(vConsole)
// }

Vue.use(Mint)
Vue.use(vant)

Vue.use(BaiduMap, {ak: 'QgpN0TiGT5vioZmuUexM3UViLpiO9RUc'})

Vue.mixin(common)
Vue.use(Vuex)
mVueTouch(Vue)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")

// 将utils设为公用
Vue.prototype.$utils = utils
Vue.prototype.$uihelper = uihelper
//获取七牛云根目录
//   getBucketDomain().then(response=>{
//     let res = response.data
//     if ( res.code == 200){
//       utils.setCookie('img_base_url',res.data.bucket_domain)
//   }
// }).catch(error=>{
//
//   })
